<template>
  <div class="page-bar-container">
    <span class="p color-orange" v-if="currentPage !== 0">Page {{currentPage}} of {{allPages}} </span>
  </div>
</template>

<script>
  export default {
    computed: {
      currentPage () {
        return this.$store.state.page
      },
      allPages () {
        return this.$store.state.pages.length - 1
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  .page-bar-container {
    position: fixed;
    z-index: 4;
    pointer-events: none;
    top: 0;
    left: 0;
    margin-top: 12px;
    margin-left: 80px;
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      position: absolute;
    }
    @media screen and (max-width: $sm-max) {
      z-index: -1;
      margin-left: 24px;
    }
  }
</style>


// WEBPACK FOOTER //
// pageBar.vue?803d42ca